import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface OverviewCard {
  tag: string;
  icon: string;
  title: string;
  desc: string;
}

interface OverviewData {
  eyebrow: string;
  title: string;
  desc: string;
  cards: OverviewCard[];
}

export default function LogisticsOverview({ data }: { data: OverviewData }) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,420px)_1fr] gap-8 lg:gap-14 items-start">
          <Reveal>
            <div>
              <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full ${a.badgeLight} text-xs font-semibold tracking-wide whitespace-nowrap`}>
                <i className="ri-compass-3-line"></i>
                {data.eyebrow}
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
                {data.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">{data.desc}</p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {data.cards.map((c) => (
                <article
                  key={c.title}
                  className="h-full rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6 flex flex-col transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="flex items-center justify-between">
                    <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                      <i className={`${c.icon} text-2xl`}></i>
                    </span>
                    <span className="text-[11px] font-semibold tracking-widest text-foreground-400">{c.tag}</span>
                  </div>
                  <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">{c.title}</h3>
                  <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed">{c.desc}</p>
                </article>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}